// AI Generated Component
import { Component, Input, OnChanges } from '@angular/core';
import { TRAFFIC_LIGHT_COLORS } from '../../constants/cookie-banner-traffic-light';

@Component({
    selector: 'cookie-banner-traffic-light',
    standalone: false,
    template: `
        <span class="cookie-banner-traffic-light {{ icon }}">

        </span>
    `,
})
export class CookieBannerTrafficLightComponent implements OnChanges {
    @Input() type: any;

    icon = '';

    ngOnChanges (): void {
        switch (this.type) {
            case TRAFFIC_LIGHT_COLORS.red:
                this.icon = 'fas fa-exclamation red';
                break;
            case TRAFFIC_LIGHT_COLORS.yellow:
                this.icon = 'fas fa-question yellow';
                break;
            default:
                this.icon = 'fas fa-check green';
                break;
        }
    }
}
